module.exports = __webpack_public_path__ + "static/media/logo_althar.ec427282.png";